import { render, staticRenderFns } from "./BookOrigin.vue?vue&type=template&id=2709cd5a&"
import script from "./BookOrigin.vue?vue&type=script&lang=js&"
export * from "./BookOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports